"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hero = void 0;
const react_1 = __importStar(require("react"));
const Hero_elements_1 = require("./Hero.elements");
const demo360_webp_1 = __importDefault(require("@images/landing/main/hero/demo360.webp"));
const demo768_webp_1 = __importDefault(require("@images/landing/main/hero/demo768.webp"));
const demo1300_webp_1 = __importDefault(require("@images/landing/main/hero/demo1300.webp"));
const demo1920_webp_1 = __importDefault(require("@images/landing/main/hero/demo1920.webp"));
const bulb_webp_1 = __importDefault(require("@images/landing/main/hero/bulb.webp"));
const darts_webp_1 = __importDefault(require("@images/landing/main/hero/darts.webp"));
const gear_webp_1 = __importDefault(require("@images/landing/main/hero/gear.webp"));
const star_webp_1 = __importDefault(require("@images/landing/main/hero/star.webp"));
const Landing_1 = require("@app/routes/Landing");
const Hero_translations_1 = require("./Hero.translations");
const Hero = ({}) => {
    const language = (0, react_1.useContext)(Landing_1.LanguageContext);
    const t = Hero_translations_1.translations[language];
    return (react_1.default.createElement(Hero_elements_1.HeroWrap, null,
        react_1.default.createElement("h1", null, t.h1),
        react_1.default.createElement("div", { className: "landing-hero-content" },
            react_1.default.createElement("div", { className: "landing-hero-content-left" },
                react_1.default.createElement("picture", { className: "landing-hero-demo" },
                    react_1.default.createElement("source", { media: "(min-width:1920px)", srcSet: demo1920_webp_1.default }),
                    react_1.default.createElement("source", { media: "(min-width:1300px)", srcSet: demo1300_webp_1.default }),
                    react_1.default.createElement("source", { media: "(min-width:768px)", srcSet: demo768_webp_1.default }),
                    react_1.default.createElement("img", { srcSet: demo360_webp_1.default, alt: "" })),
                react_1.default.createElement("ul", { className: "landing-hero-image-description" },
                    react_1.default.createElement("li", null, t.imageDesc["1"]),
                    react_1.default.createElement("li", null, t.imageDesc["2"]),
                    react_1.default.createElement("li", null, t.imageDesc["3"]),
                    react_1.default.createElement("li", null, t.imageDesc["4"]),
                    react_1.default.createElement("li", null, t.imageDesc["5"]))),
            react_1.default.createElement("div", { className: "landing-hero-content-right" },
                react_1.default.createElement("ul", { className: "landing-hero-features" },
                    react_1.default.createElement("li", { className: "landing-hero-gear" },
                        react_1.default.createElement("img", { src: gear_webp_1.default, width: 145, height: 140, alt: "" }),
                        react_1.default.createElement("span", null, t.features["1"])),
                    react_1.default.createElement("li", { className: "landing-hero-bulb" },
                        react_1.default.createElement("img", { src: bulb_webp_1.default, width: 96, height: 167, alt: "" }),
                        react_1.default.createElement("span", null, t.features["2"])),
                    react_1.default.createElement("li", { className: "landing-hero-star" },
                        react_1.default.createElement("img", { src: star_webp_1.default, width: 142, height: 141, alt: "" }),
                        react_1.default.createElement("span", null, t.features["3"])),
                    react_1.default.createElement("li", { className: "landing-hero-darts" },
                        react_1.default.createElement("img", { src: darts_webp_1.default, width: 137, height: 127, alt: "" }),
                        react_1.default.createElement("span", null, t.features["4"])))))));
};
exports.Hero = Hero;
